import type { IconName } from "@/lib/types";

const paths: Record<IconName, React.ReactNode> = {
  predict: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
      <path d="M7.5 11h1.5l1.2-2.5 1.6 5 1.2-2.5h1.5" />
    </>
  ),
  monitor: (
    <>
      <rect x="3" y="4" width="18" height="13" rx="1.5" />
      <path d="M8 21h8M12 17v4" />
      <path d="M7 12l2.5-3 2 2L15 7" />
    </>
  ),
  improve: (
    <>
      <rect x="5" y="3" width="14" height="18" rx="1.5" />
      <path d="M9 3.5h6v2H9z" />
      <path d="M8.5 10h.01M11 10h4M8.5 13.5h.01M11 13.5h4M8.5 17h.01M11 17h4" />
    </>
  ),
  repair: (
    <>
      <path d="M14.5 5.5a3.5 3.5 0 0 0-4.9 4.4L4 15.5 6.5 18l5.6-5.6a3.5 3.5 0 0 0 4.4-4.9l-2 2-1.9-.6-.6-1.9 2-2z" />
      <path d="M15 14l4 4M17 12l3 3" />
    </>
  ),
  optimize: (
    <>
      <path d="M12 21c4-2 6-5 6-9V5l-6-2-6 2v7c0 4 2 7 6 9z" />
      <path d="M12 8c-1.5 1.5-2 3-2 4.5A2 2 0 0 0 14 13c0-1.5-.5-3-2-5z" />
    </>
  ),
  develop: (
    <>
      <rect x="3" y="3" width="18" height="11" rx="1" />
      <path d="M12 14v3M7 21l5-4 5 4" />
      <path d="M7 8l2 2 5-4" />
    </>
  ),
  hospitality: (
    <>
      <path d="M3 20h18M5 20V9l7-4 7 4v11" />
      <path d="M9 20v-4h6v4M9 11h.01M15 11h.01" />
    </>
  ),
  pharma: (
    <>
      <rect x="3" y="9" width="11" height="7" rx="3.5" transform="rotate(45 8.5 12.5)" />
      <path d="M11 7l5 5" />
      <circle cx="18" cy="6" r="2.5" />
    </>
  ),
  manufacturing: (
    <>
      <path d="M3 21V10l5 3V10l5 3V6l5 3v12z" />
      <path d="M3 21h18" />
    </>
  ),
  food: (
    <>
      <rect x="8" y="9" width="8" height="12" rx="2" />
      <path d="M9 9V6a3 3 0 0 1 6 0v3M8 13h8" />
    </>
  ),
  realestate: (
    <>
      <rect x="4" y="3" width="16" height="18" rx="1" />
      <path d="M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2M10 21v-3h4v3" />
    </>
  ),
  healthcare: (
    <>
      <path d="M12 4a4 4 0 0 0-8 0v5a8 8 0 0 0 16 0V7a3 3 0 0 0-6 0v3" />
      <circle cx="18" cy="13" r="2.5" />
      <path d="M9 9h6M12 6v6" />
    </>
  ),
  datacenter: (
    <>
      <rect x="4" y="3" width="16" height="6" rx="1" />
      <rect x="4" y="11" width="16" height="6" rx="1" />
      <path d="M8 6h.01M8 14h.01M6 19v2M18 19v2M6 9v2M18 9v2" />
    </>
  ),
  water: (
    <>
      <path d="M12 3s6 6 6 10a6 6 0 0 1-12 0c0-4 6-10 6-10z" />
      <path d="M9.5 13a2.5 2.5 0 0 0 2.5 2.5" />
    </>
  ),
  energy: (
    <>
      <path d="M13 2 4 14h6l-1 8 9-12h-6z" />
    </>
  ),
  mining: (
    <>
      <path d="M14 3l7 7-2 2-3-3-7 7" />
      <path d="M3 21l6-6M3 21l4-1 1-3" />
    </>
  ),
  oil: (
    <>
      <path d="M7 21V8l5-5 5 5v13" />
      <path d="M7 12h10M7 16h10M12 3v18" />
    </>
  ),
  government: (
    <>
      <path d="M3 21h18M4 21V10h16v11M3 10l9-6 9 6" />
      <path d="M8 21v-7M12 21v-7M16 21v-7" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3 5 6v5c0 4 3 7 7 9 4-2 7-5 7-9V6z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  gauge: (
    <>
      <path d="M4 18a8 8 0 1 1 16 0" />
      <path d="M12 18l4-5" />
      <circle cx="12" cy="18" r="1" />
    </>
  ),
  leaf: (
    <>
      <path d="M5 19c0-8 6-13 14-13 0 8-5 14-13 14a6 6 0 0 1-1-1z" />
      <path d="M5 19c3-5 7-8 11-9" />
    </>
  ),
  wrench: (
    <>
      <path d="M14.5 5.5a3.5 3.5 0 0 0-4.9 4.4L4 15.5 6.5 18l5.6-5.6a3.5 3.5 0 0 0 4.4-4.9l-2 2-1.9-.6-.6-1.9 2-2z" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v4l3 2" />
    </>
  ),
  chart: (
    <>
      <path d="M4 20V4M4 20h16" />
      <path d="M8 16v-4M12 16V8M16 16v-6" />
    </>
  ),
  check: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="m8.5 12 2.5 2.5 4.5-5" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="12" cy="12" r="1" fill="currentColor" />
    </>
  ),
  handshake: (
    <>
      <path d="M3 13l4-4 3 2 4-4 4 3 3-2v6l-4 4-3-2-4 3-4-3-3 2z" />
      <path d="M10 11l2 2 3-3" />
    </>
  ),
  dollar: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M15 9c-1-1-2-1.5-3-1.5S9.5 8 9.5 9.5s1.5 2 2.5 2 2.5.5 2.5 2-1.5 2-2.5 2-2-.5-3-1.5" />
      <path d="M12 6v12" />
    </>
  ),
  hardhat: (
    <>
      <path d="M4 18h16v-2c0-4-3.5-7-8-7s-8 3-8 7v2z" />
      <path d="M10 9V5h4v4" />
      <path d="M3 18h18" />
    </>
  ),
  alert: (
    <>
      <path d="M12 3 2 20h20z" />
      <path d="M12 10v5M12 17.5v.5" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </>
  ),
  analyze: (
    <>
      <path d="M3 21V8M3 21h18" />
      <path d="M7 17V11M11 17V8M15 17v-3M19 17V7" />
      <path d="M17 5l-2 3-4-2-5 3" />
    </>
  ),
  design: (
    <>
      <rect x="5" y="3" width="14" height="18" rx="1.5" />
      <path d="M9 3.5h6v2H9z" />
      <path d="M8 10l2 2 4-4M8 16l2 2 4-4" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3h0a1.7 1.7 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8v0a1.7 1.7 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
    </>
  ),
  people: (
    <>
      <circle cx="9" cy="8" r="3" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M3 20c0-3 3-5 6-5s6 2 6 5" />
      <path d="M14 20c0-2.5 2-4 4-4s3 1 3 4" />
    </>
  ),
  building: (
    <>
      <rect x="4" y="3" width="16" height="18" rx="1" />
      <path d="M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2" />
      <path d="M10 21v-3h4v3" />
    </>
  ),
  factory: (
    <>
      <path d="M3 21V11l5 3V11l5 3V8l5 3v10z" />
      <path d="M3 21h18M7 18h2M13 18h2" />
    </>
  ),
  compliance: (
    <>
      <rect x="5" y="3" width="14" height="18" rx="1.5" />
      <path d="M9 3.5h6v2H9z" />
      <path d="m8.5 13 2 2 4-4" />
    </>
  ),
  briefcase: (
    <>
      <rect x="3" y="7" width="18" height="13" rx="1.5" />
      <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
      <path d="M3 13h18" />
    </>
  ),
  trend: (
    <>
      <path d="M3 17l6-6 4 4 8-8" />
      <path d="M14 7h7v7" />
    </>
  ),
  cycle: (
    <>
      <path d="M4 12a8 8 0 0 1 14-5l2-1v6h-6l2-2a5 5 0 1 0 .5 7" />
    </>
  ),
  speedometer: (
    <>
      <path d="M4 18a8 8 0 1 1 16 0" />
      <path d="M12 18l5-4" />
      <circle cx="12" cy="18" r="1" />
      <path d="M6 18h.01M18 18h.01" />
    </>
  ),
  lightbulb: (
    <>
      <path d="M9 18h6M10 21h4" />
      <path d="M12 3a6 6 0 0 0-4 10.5c.7.7 1 1.5 1 2.5h6c0-1 .3-1.8 1-2.5A6 6 0 0 0 12 3z" />
    </>
  ),
  graduation: (
    <>
      <path d="M2 9l10-5 10 5-10 5z" />
      <path d="M6 11v5c0 1.5 3 3 6 3s6-1.5 6-3v-5" />
    </>
  ),
  warning: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v6M12 16v.5" />
    </>
  ),
  truck: (
    <>
      <rect x="1" y="7" width="13" height="10" rx="1.5" />
      <path d="M14 10h4l3 3v4h-7z" />
      <circle cx="6" cy="18.5" r="1.8" />
      <circle cx="18" cy="18.5" r="1.8" />
    </>
  ),
  train: (
    <>
      <rect x="4" y="3" width="16" height="13" rx="3" />
      <path d="M4 11h16M9 7h6" />
      <path d="M7 20l-2 2M17 20l2 2" />
      <circle cx="8" cy="13.5" r="1" />
      <circle cx="16" cy="13.5" r="1" />
    </>
  ),
  ship: (
    <>
      <path d="M3 17l1.5 3h15L21 17" />
      <path d="M5 17V9h14v8" />
      <path d="M12 4v5M9 9h6" />
    </>
  ),
  plug: (
    <>
      <path d="M9 2v6M15 2v6" />
      <rect x="7" y="8" width="10" height="6" rx="1" />
      <path d="M12 14v4a2 2 0 0 0 2 2h3" />
    </>
  ),
  whatsapp: (
    <path
      fill="currentColor"
      stroke="none"
      d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91a9.83 9.83 0 0 0-2.91-7.01zM12.04 20.15h-.01a8.22 8.22 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.18 8.18 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24a8.19 8.19 0 0 1 5.83 2.42 8.19 8.19 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.23 8.23zm4.52-6.16c-.25-.13-1.47-.72-1.69-.81-.23-.08-.39-.13-.56.13-.16.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.72-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.13-.56-1.35-.77-1.85-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.86.84-.86 2.05 0 1.21.88 2.38 1 2.55.12.17 1.73 2.65 4.2 3.71.59.25 1.05.4 1.4.52.59.19 1.12.16 1.55.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.11-.23-.17-.48-.3z"
    />
  ),
  headset: (
    <>
      <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
      <path d="M4 14h3v6H5a1 1 0 0 1-1-1z" />
      <path d="M20 14h-3v6h2a1 1 0 0 0 1-1z" />
      <path d="M12 20a4 4 0 0 0 4-4" />
    </>
  ),
  phone: (
    <path d="M5.5 3h3l2 5-2.5 1.5a11 11 0 0 0 5.5 5.5L15 12.5l5 2v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 3.5 5.2 2 2 0 0 1 5.5 3z" />
  ),
  envelope: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="1.5" />
      <path d="m3 7 9 6 9-6" />
    </>
  ),
  pin: (
    <>
      <path d="M12 22c-4-5-7-8.5-7-12a7 7 0 1 1 14 0c0 3.5-3 7-7 12z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
};

export function Icon({
  name,
  className = "",
  size = 28,
}: {
  name: IconName;
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {paths[name] ?? paths.check}
    </svg>
  );
}

export function Arrow({ className = "" }: { className?: string }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/**
 * Brand logo.
 *
 * - When `imageUrl` is provided, the uploaded image replaces the SVG + wordmark.
 * - Otherwise the built-in SVG glyph renders next to `companyName` and `tagline`.
 *
 * `companyName` / `tagline` default to the original brand so call-sites that
 * don't pass props (e.g. the 404 page) still render correctly.
 */
export function Logo({
  className = "",
  light = false,
  companyName = "ASSADORA",
  tagline = "RELIABILITY. PERFORMANCE. RESULTS.",
  imageUrl,
  alt = "Assadora",
}: {
  className?: string;
  light?: boolean;
  companyName?: string;
  tagline?: string;
  imageUrl?: string;
  alt?: string;
}) {
  if (imageUrl) {
    const taglineLines = tagline.split(/\s+/).filter(Boolean);
    return (
      <span className={`inline-flex items-center gap-0 -ml-1 ${className}`} aria-label={alt}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={imageUrl}
          alt=""
          className={`h-16 w-auto sm:h-20 ${light ? "brightness-0 invert" : "dark:brightness-0 dark:invert"}`}
        />
        <span className={`ml-3 flex flex-col gap-0.5 text-[5px] font-bold leading-none tracking-[0.18em] sm:text-[7px] ${light ? "text-white/80" : "text-navy/80 dark:text-white/80"}`}>
          {taglineLines.map((line, i) => (
            <span key={i}>{line}</span>
          ))}
        </span>
      </span>
    );
  }
  const c = light ? "#ffffff" : "#232f58";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} aria-label={alt}>
      <svg width="38" height="36" viewBox="0 0 46 44" aria-hidden="true">
        {/* thick left leg */}
        <polygon points="21,4 25,4 12,42 3,42" fill={c} />
        {/* thin right leg */}
        <polygon points="25,4 28,4 43,42 40,42" fill={c} />
        {/* base foot */}
        <polygon points="13,39 44,39 44,42 13,42" fill={c} />
        {/* red crossbar */}
        <polygon points="12,32 30,27 32,32 14,37" fill="#c52127" />
      </svg>
      <span className="flex flex-col leading-none">
        <span className={`text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-navy"}`}>
          {companyName}
        </span>
        <span className={`text-[8px] font-semibold tracking-[0.18em] ${light ? "text-white/70" : "text-gray-500"}`}>
          {tagline}
        </span>
      </span>
    </span>
  );
}